import {NgModule} from '@angular/core'
import {CommonModule} from '@angular/common'
import {FormsModule, ReactiveFormsModule} from '@angular/forms'
import {SearchFilterComponent} from './search-filter.component'
import {RangeFilterComponent} from './range-filter/range-filter.component'
import {DatetimePickerComponent} from './datetime-picker/datetime-picker.component'

import {SinceComponent} from './since/since.component'
import {FilterValueFormComponent} from './filter-value-form/filter-value-form.component'
import {BsDatepickerModule} from 'ngx-bootstrap/datepicker'
import {TimepickerModule} from 'ngx-bootstrap/timepicker'
import {TooltipModule} from 'ngx-bootstrap/tooltip'
import {NgbModule} from '@ng-bootstrap/ng-bootstrap'

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    BsDatepickerModule,
    TimepickerModule,
    TooltipModule,
    NgbModule,
  ],
  declarations: [
    SearchFilterComponent,
    RangeFilterComponent,
    DatetimePickerComponent,
    SinceComponent,
    FilterValueFormComponent,
  ],
  exports: [SearchFilterComponent],
})
export class SearchFilterModule {}
